import { render, staticRenderFns } from "./ShippingLocalDocumentList.vue?vue&type=template&id=9c8038ce&scoped=true"
import script from "./ShippingLocalDocumentList.vue?vue&type=script&lang=js"
export * from "./ShippingLocalDocumentList.vue?vue&type=script&lang=js"
import style0 from "./ShippingLocalDocumentList.vue?vue&type=style&index=0&id=9c8038ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8038ce",
  null
  
)

export default component.exports